<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <article class="is-child box">
            <h4 class="title" style="font-size: 18px;"><input type="checkbox" v-model="invoiceRule.multi.active" @change="activeRules()"/> <b>Multi(National/International)</b></h4>
            <div class="control">
              <p class="control">
                <label class="label">Date Type</label>
                <select class="select is-fullwidth" v-model="invoiceRule.multi.date_type" name="date_type_multi" id="date_type_multi" :disabled="!invoiceRule.multi.active">
                  <option value="service_date">Check-in</option>
                  <option value="checkout">Check-out</option>
                  <option value="reservation_date">Creation</option>
                </select>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.multi.single" :disabled="!invoiceRule.multi.active"/> Single</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.multi.daily" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1) || (invoiceRule.multi.biweekly === true) || (parseInt(invoiceRule.multi.biweekly) === 1) || (invoiceRule.multi.monthly === true) || (parseInt(invoiceRule.multi.monthly) === 1))"/> Daily</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.multi.decendial" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.daily === true) || (parseInt(invoiceRule.multi.daily) === 1) || (invoiceRule.multi.biweekly === true) || (parseInt(invoiceRule.multi.biweekly) === 1) || (invoiceRule.multi.monthly === true) || (parseInt(invoiceRule.multi.monthly) === 1))"/> Decendial</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.multi.biweekly" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.daily === true) || (parseInt(invoiceRule.multi.daily) === 1) || (invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1 ) || (invoiceRule.multi.monthly === true) || (parseInt(invoiceRule.multi.monthly) === 1 ))"/> Biweekly</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.multi.monthly" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.daily === true) || (parseInt(invoiceRule.multi.daily) === 1) || (invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1 ) || (invoiceRule.multi.biweekly === true) || (parseInt(invoiceRule.multi.biweekly) === 1 ))"/> Monthly</label>
              </p>
              <p class="control" v-if="((invoiceRule.multi.daily === true) || (parseInt(invoiceRule.multi.daily) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="daily_days_multi" id="daily_days_multi" placeholder="1" v-model="invoiceRule.multi.daily_days" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.multi.biweekly === true) || (parseInt(invoiceRule.multi.biweekly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="biweekly_days_multi" id="biweekly_days_multi" placeholder="1" v-model="invoiceRule.multi.biweekly_days" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.multi.monthly === true) || (parseInt(invoiceRule.multi.monthly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="monthly_days_multi" id="monthly_days_multi" placeholder="1" v-model="invoiceRule.multi.monthly_days" :disabled="!invoiceRule.multi.active || ((invoiceRule.multi.decendial === true) || (parseInt(invoiceRule.multi.decendial) === 1 ))">
              </p>
              <div class="control is-vertical" v-if="(((invoiceRule.multi.daily === false) || (parseInt(invoiceRule.multi.daily) === 0 )) && ((invoiceRule.multi.decendial === false) || (parseInt(invoiceRule.multi.decendial) === 0 )) && ((invoiceRule.multi.biweekly === false) || (parseInt(invoiceRule.multi.biweekly) === 0)) && ((invoiceRule.multi.monthly === false) || (parseInt(invoiceRule.multi.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.day_week_interval" name="day_week_interval_multi" id="day_week_interval_multi" :disabled="!invoiceRule.multi.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.week_interval" name="week_interval_multi" id="week_interval_multi" :disabled="!invoiceRule.multi.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Interval</label>
                    <input :class="{'input': true, 'is-danger': errors.has('days_interval_multi')}" type="text" name="days_interval_multi" id="days_interval_multi" placeholder="Days Interval" v-model="invoiceRule.multi.days_interval" v-validate="'numeric|min_value:7'" :disabled="!invoiceRule.multi.active">
                    <span v-show="errors.has('days_interval_multi')" class="help is-danger">{{ errors.first('days_interval_multi') }}</span>
                  </p>
                  <p class="control">
                    <label class="label">Base Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.base_interval" name="base_interval_natio" id="base_interval_natio" :disabled="!invoiceRule.multi.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <div class="control is-vertical" v-if="(((invoiceRule.multi.daily === false) || (parseInt(invoiceRule.multi.daily) === 0 )) && ((invoiceRule.multi.decendial === false) || (parseInt(invoiceRule.multi.decendial) === 0 )) && ((invoiceRule.multi.biweekly === false) || (parseInt(invoiceRule.multi.biweekly) === 0)) && ((invoiceRule.multi.monthly === false) || (parseInt(invoiceRule.multi.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.day_week_deadline" name="day_week_deadline_multi" id="day_week_deadline_multi" :disabled="!invoiceRule.multi.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.week_deadline" name="week_deadline_multi" id="week_deadline_multi" :disabled="!invoiceRule.multi.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Deadline</label>
                    <input class="input" type="text" name="days_deadline_multi" id="days_deadline_multi" placeholder="Days Deadline" v-model="invoiceRule.multi.days_deadline" :disabled="!invoiceRule.multi.active">
                  </p>
                  <p class="control">
                    <label class="label">Base Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.multi.base_deadline" name="base_deadline_multi" id="base_deadline_multi" :disabled="!invoiceRule.multi.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <p class="control">
                Date INI: {{date_ini_multi}}<br/>
                Date END: {{date_end_multi}}<br/>
                Deadline: {{deadline_multi}}
              </p>
            </div>
          </article>
          <article class="is-child box" v-show="!invoiceRule.multi.active">
            <h4 class="title" style="font-size: 18px;"><input type="checkbox" v-model="invoiceRule.national.active"/> <b>National</b></h4>
            <div class="control">
              <p class="control">
                <label class="label">Date Type</label>
                <select class="select is-fullwidth" v-model="invoiceRule.national.date_type" name="date_type_natio" id="date_type_natio" :disabled="!invoiceRule.national.active">
                  <option value="service_date">Check-in</option>
                  <option value="checkout">Check-out</option>
                  <option value="reservation_date">Creation</option>
                </select>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.national.single" :disabled="!invoiceRule.national.active"/> Single</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.national.daily" :disabled="!invoiceRule.national.active || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ) || (invoiceRule.national.biweekly === true) || (parseInt(invoiceRule.national.biweekly) === 1) || (invoiceRule.national.monthly === true) || (parseInt(invoiceRule.national.monthly) === 1))"/> Daily</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.national.decendial" :disabled="!invoiceRule.national.active || (invoiceRule.national.daily === true) || (parseInt(invoiceRule.national.daily) === 1 ) || ((invoiceRule.national.biweekly === true) || (parseInt(invoiceRule.national.biweekly) === 1) || (invoiceRule.national.monthly === true) || (parseInt(invoiceRule.national.monthly) === 1))"/> Decendial</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.national.biweekly" :disabled="!invoiceRule.national.active || (invoiceRule.national.daily === true) || (parseInt(invoiceRule.national.daily) === 1 ) || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ) || (invoiceRule.national.monthly === true) || (parseInt(invoiceRule.national.monthly) === 1 ))"/> Biweekly</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.national.monthly" :disabled="!invoiceRule.national.active || (invoiceRule.national.daily === true) || (parseInt(invoiceRule.national.daily) === 1 ) || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ) || (invoiceRule.national.biweekly === true) || (parseInt(invoiceRule.national.biweekly) === 1 ))"/> Monthly</label>
              </p>
              <p class="control" v-if="((invoiceRule.national.daily === true) || (parseInt(invoiceRule.national.daily) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="daily_days_natio" id="daily_days_natio" placeholder="1" v-model="invoiceRule.national.daily_days" :disabled="!invoiceRule.national.active || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.national.biweekly === true) || (parseInt(invoiceRule.national.biweekly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="biweekly_days_natio" id="biweekly_days_natio" placeholder="1" v-model="invoiceRule.national.biweekly_days" :disabled="!invoiceRule.national.active || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.national.monthly === true) || (parseInt(invoiceRule.national.monthly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="monthly_days_natio" id="monthly_days_natio" placeholder="1" v-model="invoiceRule.national.monthly_days" :disabled="!invoiceRule.national.active || ((invoiceRule.national.decendial === true) || (parseInt(invoiceRule.national.decendial) === 1 ))">
              </p>
              <div class="control is-vertical" v-if="(((invoiceRule.national.daily === false) || (parseInt(invoiceRule.national.daily) === 0 )) && ((invoiceRule.national.decendial === false) || (parseInt(invoiceRule.national.decendial) === 0 )) && ((invoiceRule.national.biweekly === false) || (parseInt(invoiceRule.national.biweekly) === 0)) && ((invoiceRule.national.monthly === false) || (parseInt(invoiceRule.national.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.day_week_interval" name="day_week_interval_natio" id="day_week_interval_natio" :disabled="!invoiceRule.national.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.week_interval" name="week_interval_natio" id="week_interval_natio" :disabled="!invoiceRule.national.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Interval</label>
                    <input :class="{'input': true, 'is-danger': errors.has('days_interval_natio')}" type="text" name="days_interval_natio" id="days_interval_natio" placeholder="Days Interval" v-model="invoiceRule.national.days_interval" v-validate="'numeric|min_value:7'" :disabled="!invoiceRule.national.active">
                    <span v-show="errors.has('days_interval_natio')" class="help is-danger">{{ errors.first('days_interval_natio') }}</span>
                  </p>
                  <p class="control">
                    <label class="label">Base Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.base_interval" name="base_interval_natio" id="base_interval_natio" :disabled="!invoiceRule.national.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <div class="control is-vertical" v-if="(((invoiceRule.national.daily === false) || (parseInt(invoiceRule.national.daily) === 0 )) && ((invoiceRule.national.decendial === false) || (parseInt(invoiceRule.national.decendial) === 0 )) && ((invoiceRule.national.biweekly === false) || (parseInt(invoiceRule.national.biweekly) === 0)) && ((invoiceRule.national.monthly === false) || (parseInt(invoiceRule.national.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.day_week_deadline" name="day_week_deadline_natio" id="day_week_deadline_natio" :disabled="!invoiceRule.national.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.week_deadline" name="week_deadline_natio" id="week_deadline_natio" :disabled="!invoiceRule.national.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Deadline</label>
                    <input class="input" type="text" name="days_deadline_natio" id="days_deadline_natio" placeholder="Days Deadline" v-model="invoiceRule.national.days_deadline" :disabled="!invoiceRule.national.active">
                  </p>
                  <p class="control">
                    <label class="label">Base Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.national.base_deadline" name="base_deadline_natio" id="base_deadline_natio" :disabled="!invoiceRule.national.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <p class="control">
                Date INI: {{date_ini_natio}}<br/>
                Date END: {{date_end_natio}}<br/>
                Deadline: {{deadline_natio}}
              </p>
            </div>
          </article>
          <article class="is-child box" v-show="!invoiceRule.multi.active">
            <h4 class="title" style="font-size: 18px;"><input type="checkbox" v-model="invoiceRule.international.active"/> <b>International</b></h4>
            <div class="control">
              <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress, 'is-success': true}" @click="copyRules()">Copy National</a>
              <p class="control">
                <label class="label">Date Type</label>
                <select class="select is-fullwidth" v-model="invoiceRule.international.date_type" name="date_type_inter" id="date_type_inter" :disabled="!invoiceRule.international.active">
                  <option value="service_date">Check-in</option>
                  <option value="checkout">Check-out</option>
                  <option value="reservation_date">Creation</option>
                </select>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.international.single" :disabled="!invoiceRule.international.active"/> Single</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.international.daily" :disabled="!invoiceRule.international.active || ((invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ) || (invoiceRule.international.biweekly === true) || (parseInt(invoiceRule.international.biweekly) === 1) || (invoiceRule.international.monthly === true) || (parseInt(invoiceRule.international.monthly) === 1))"/> Daily</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.international.decendial" :disabled="!invoiceRule.international.active || ((invoiceRule.international.daily === true) || (parseInt(invoiceRule.international.daily) === 1) || (invoiceRule.international.biweekly === true) || (parseInt(invoiceRule.international.biweekly) === 1) || (invoiceRule.international.monthly === true) || (parseInt(invoiceRule.international.monthly) === 1))"/> Decendial</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.international.biweekly" :disabled="!invoiceRule.international.active || ((invoiceRule.international.daily === true) || (parseInt(invoiceRule.international.daily) === 1) || (invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ) || (invoiceRule.international.monthly === true) || (parseInt(invoiceRule.international.monthly) === 1 ))"/> Biweekly</label>
              </p>
              <p class="control">
                <label class="label"><input type="checkbox" v-model="invoiceRule.international.monthly" :disabled="!invoiceRule.international.active || ((invoiceRule.international.daily === true) || (parseInt(invoiceRule.international.daily) === 1) || (invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ) || (invoiceRule.international.biweekly === true) || (parseInt(invoiceRule.international.biweekly) === 1 ))"/> Monthly</label>
              </p>
              <p class="control" v-if="((invoiceRule.international.daily === true) || (parseInt(invoiceRule.international.daily) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="daily_days_inter" id="daily_days_inter" placeholder="1" v-model="invoiceRule.international.daily_days" :disabled="!invoiceRule.international.active || ((invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.international.biweekly === true) || (parseInt(invoiceRule.international.biweekly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="biweekly_days_inter" id="biweekly_days_inter" placeholder="1" v-model="invoiceRule.international.biweekly_days" :disabled="!invoiceRule.international.active || ((invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ))">
              </p>
              <p class="control" v-if="((invoiceRule.international.monthly === true) || (parseInt(invoiceRule.international.monthly) === 1))">
                <label class="label">Days Deadline</label>
                <input class="input" type="text" name="monthly_days_inter" id="monthly_days_inter" placeholder="1" v-model="invoiceRule.international.monthly_days" :disabled="!invoiceRule.international.active || ((invoiceRule.international.decendial === true) || (parseInt(invoiceRule.international.decendial) === 1 ))">
              </p>
              <div class="control is-vertical" v-if="(((invoiceRule.international.daily === false) || (parseInt(invoiceRule.international.daily) === 0 )) && ((invoiceRule.international.decendial === false) || (parseInt(invoiceRule.international.decendial) === 0 )) && ((invoiceRule.international.biweekly === false) || (parseInt(invoiceRule.international.biweekly) === 0)) && ((invoiceRule.international.monthly === false) || (parseInt(invoiceRule.international.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.day_week_interval" name="day_week_interval_inter" id="day_week_interval_inter" :disabled="!invoiceRule.international.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.week_interval" name="week_interval_inter" id="week_interval_inter" :disabled="!invoiceRule.international.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Interval</label>
                    <input :class="{'input': true, 'is-danger': errors.has('days_interval_inter')}" type="text" name="days_interval_inter" id="days_interval_inter" placeholder="Days Interval" v-model="invoiceRule.international.days_interval" v-validate="'numeric|min_value:7'" :disabled="!invoiceRule.international.active">
                    <span v-show="errors.has('days_interval_inter')" class="help is-danger">{{ errors.first('days_interval_inter') }}</span>
                  </p>
                  <p class="control">
                    <label class="label">Base Interval</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.base_interval" name="base_interval_inter" id="base_interval_inter" :disabled="!invoiceRule.international.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <div class="control is-vertical" v-if="(((invoiceRule.international.daily === false) || (parseInt(invoiceRule.international.daily) === 0 )) && ((invoiceRule.international.decendial === false) || (parseInt(invoiceRule.international.decendial) === 0 )) && ((invoiceRule.international.biweekly === false) || (parseInt(invoiceRule.international.biweekly) === 0)) && ((invoiceRule.international.monthly === false) || (parseInt(invoiceRule.international.monthly) === 0)))">
                <div class="control is-grouped">
                  <p class="control">
                    <label class="label">Day Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.day_week_deadline" name="day_week_deadline_inter" id="day_week_deadline_inter" :disabled="!invoiceRule.international.active">
                      <option value="monday">Monday (Mon)</option>
                      <option value="tuesday">Tuesday (Tue) (Tues)</option>
                      <option value="wednesday">Wednesday (Wed)</option>
                      <option value="thursday">Thursday (Thur) (Thurs)</option>
                      <option value="friday">Friday (Fri)</option>
                      <option value="saturday">Saturday (Sat)</option>
                      <option value="sunday">Sunday (Sun)</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Week Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.week_deadline" name="week_deadline_inter" id="week_deadline_inter" :disabled="!invoiceRule.international.active">
                      <option value="last">Last</option>
                      <option value="this">This</option>
                      <option value="next">Next</option>
                    </select>
                  </p>
                  <p class="control">
                    <label class="label">Days Deadline</label>
                    <input class="input" type="text" name="days_deadline_inter" id="days_deadline_inter" placeholder="Days Deadline" v-model="invoiceRule.international.days_deadline" :disabled="!invoiceRule.international.active">
                  </p>
                  <p class="control">
                    <label class="label">Base Deadline</label>
                    <select class="select is-fullwidth" v-model="invoiceRule.international.base_deadline" name="base_deadline_inter" id="base_deadline_inter" :disabled="!invoiceRule.international.active">
                      <option value="days">Days</option>
                      <option value="month">Month</option>
                    </select>
                  </p>
                </div>
              </div>
              <p class="control">
                Date INI: {{date_ini_inter}}<br/>
                Date END: {{date_end_inter}}<br/>
                Deadline: {{deadline_inter}}
              </p>
            </div>
          </article>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a><a :class="{'button': true, 'is-primary': true, 'is-disabled': errors.any() || inProgress, 'is-success': true}" @click="saveRules(true)">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      title: {
        type: String
      },
      agency_id: {
        type: Number
      }
    },
    data () {
      return {
        date_ini_natio: '',
        date_end_natio: '',
        deadline_natio: '',
        date_ini_inter: '',
        date_end_inter: '',
        deadline_inter: '',
        date_ini_multi: '',
        date_end_multi: '',
        deadline_multi: '',
        invoiceRule: {
          agency_id: '',
          multi: {
            id: null,
            date_type: 'service_date',
            single: false,
            daily: false,
            daily_days: 0,
            decendial: false,
            biweekly: false,
            biweekly_days: 0,
            monthly: false,
            monthly_days: 0,
            days_interval: 0,
            base_interval: 'days',
            day_week_interval: 'monday',
            week_interval: 'this',
            days_deadline: 0,
            base_deadline: 'days',
            day_week_deadline: 'monday',
            week_deadline: 'this',
            active: false
          },
          international: {
            id: null,
            date_type: 'service_date',
            single: false,
            daily: false,
            daily_days: 0,
            decendial: false,
            biweekly: false,
            biweekly_days: 0,
            monthly: false,
            monthly_days: 0,
            days_interval: 0,
            base_interval: 'days',
            day_week_interval: 'monday',
            week_interval: 'this',
            days_deadline: 0,
            base_deadline: 'days',
            day_week_deadline: 'monday',
            week_deadline: 'this',
            active: false
          },
          national: {
            id: null,
            date_type: 'service_date',
            single: false,
            daily: false,
            daily_days: 0,
            decendial: false,
            biweekly: false,
            biweekly_days: 0,
            monthly: false,
            monthly_days: 0,
            days_interval: 0,
            base_interval: 'days',
            day_week_interval: 'monday',
            week_interval: 'this',
            days_deadline: 0,
            base_deadline: 'days',
            day_week_deadline: 'monday',
            week_deadline: 'this',
            active: false
          }
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.invoiceRule.agency_id = this.agency_id
        this.loadRules()
      })
    },
    methods: {
      activeRules () {
        if (this.invoiceRule.multi.active) {
          this.invoiceRule.international.active = false
          this.invoiceRule.national.active = false
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      copyRules () {
        this.invoiceRule.international.date_type = this.invoiceRule.national.date_type
        this.invoiceRule.international.single = this.invoiceRule.national.single
        this.invoiceRule.international.daily = this.invoiceRule.national.daily
        this.invoiceRule.international.daily_days = this.invoiceRule.national.daily_days
        this.invoiceRule.international.decendial = this.invoiceRule.national.decendial
        this.invoiceRule.international.biweekly = this.invoiceRule.national.biweekly
        this.invoiceRule.international.biweekly_days = this.invoiceRule.national.biweekly_days
        this.invoiceRule.international.monthly = this.invoiceRule.national.monthly
        this.invoiceRule.international.monthly_days = this.invoiceRule.national.monthly_days

        this.invoiceRule.international.days_interval = this.invoiceRule.national.days_interval
        this.invoiceRule.international.base_interval = this.invoiceRule.national.base_interval
        this.invoiceRule.international.day_week_interval = this.invoiceRule.national.day_week_interval
        this.invoiceRule.international.week_interval = this.invoiceRule.national.week_interval
        // deadline
        this.invoiceRule.international.days_deadline = this.invoiceRule.national.days_deadline
        this.invoiceRule.international.base_deadline = this.invoiceRule.national.base_deadline
        this.invoiceRule.international.day_week_deadline = this.invoiceRule.national.day_week_deadline
        this.invoiceRule.international.week_deadline = this.invoiceRule.national.week_deadline

        this.invoiceRule.international.active = this.invoiceRule.national.active
      },
      saveRules () {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/agencies/' + this.agency_id + '/rules', this.invoiceRule).then((response) => {
          this.inProgress = false
          this.date_ini_natio = response.body.date_ini_natio
          this.date_end_natio = response.body.date_end_natio
          this.deadline_natio = response.body.deadline_natio

          this.date_ini_inter = response.body.date_ini_inter
          this.date_end_inter = response.body.date_end_inter
          this.deadline_inter = response.body.deadline_inter

          this.date_ini_multi = response.body.date_ini_multi
          this.date_end_multi = response.body.date_end_multi
          this.deadline_multi = response.body.deadline_multi
          // this.loadRules()
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      loadRules () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/' + this.agency_id + '/rules').then((response) => {
          if (response.body.length > 0) {
            response.body.forEach(rule => {
              if (rule.international === 0) {
                this.invoiceRule.national.id = rule.id
                this.invoiceRule.national.date_type = rule.date_type
                this.invoiceRule.national.single = rule.single
                this.invoiceRule.national.daily = rule.daily
                this.invoiceRule.national.daily_days = rule.daily_days
                this.invoiceRule.national.decendial = rule.decendial
                this.invoiceRule.national.biweekly = rule.biweekly
                this.invoiceRule.national.biweekly_days = rule.biweekly_days
                this.invoiceRule.national.monthly = rule.monthly
                this.invoiceRule.national.monthly_days = rule.monthly_days
                // interval
                this.invoiceRule.national.days_interval = rule.days_interval
                this.invoiceRule.national.base_interval = rule.base_interval
                this.invoiceRule.national.day_week_interval = rule.day_week_interval
                this.invoiceRule.national.week_interval = rule.week_interval
                // deadline
                this.invoiceRule.national.days_deadline = rule.days_deadline
                this.invoiceRule.national.base_deadline = rule.base_deadline
                this.invoiceRule.national.day_week_deadline = rule.day_week_deadline
                this.invoiceRule.national.week_deadline = rule.week_deadline

                this.invoiceRule.national.active = rule.active
              } else if (rule.international === 1) {
                this.invoiceRule.international.id = rule.id
                this.invoiceRule.international.date_type = rule.date_type
                this.invoiceRule.international.single = rule.single
                this.invoiceRule.international.daily = rule.daily
                this.invoiceRule.international.daily_days = rule.daily_days
                this.invoiceRule.international.decendial = rule.decendial
                this.invoiceRule.international.biweekly = rule.biweekly
                this.invoiceRule.international.biweekly_days = rule.biweekly_days
                this.invoiceRule.international.monthly = rule.monthly
                this.invoiceRule.international.monthly_days = rule.monthly_days
                // interval
                this.invoiceRule.international.days_interval = rule.days_interval
                this.invoiceRule.international.base_interval = rule.base_interval
                this.invoiceRule.international.day_week_interval = rule.day_week_interval
                this.invoiceRule.international.week_interval = rule.week_interval
                // deadline
                this.invoiceRule.international.days_deadline = rule.days_deadline
                this.invoiceRule.international.base_deadline = rule.base_deadline
                this.invoiceRule.international.day_week_deadline = rule.day_week_deadline
                this.invoiceRule.international.week_deadline = rule.week_deadline

                this.invoiceRule.international.active = rule.active
              } else if (rule.international === 2) {
                this.invoiceRule.multi.id = rule.id
                this.invoiceRule.multi.date_type = rule.date_type
                this.invoiceRule.multi.single = rule.single
                this.invoiceRule.multi.daily = rule.daily
                this.invoiceRule.multi.daily_days = rule.daily_days
                this.invoiceRule.multi.decendial = rule.decendial
                this.invoiceRule.multi.biweekly = rule.biweekly
                this.invoiceRule.multi.biweekly_days = rule.biweekly_days
                this.invoiceRule.multi.monthly = rule.monthly
                this.invoiceRule.multi.monthly_days = rule.monthly_days
                // interval
                this.invoiceRule.multi.days_interval = rule.days_interval
                this.invoiceRule.multi.base_interval = rule.base_interval
                this.invoiceRule.multi.day_week_interval = rule.day_week_interval
                this.invoiceRule.multi.week_interval = rule.week_interval
                // deadline
                this.invoiceRule.multi.days_deadline = rule.days_deadline
                this.invoiceRule.multi.base_deadline = rule.base_deadline
                this.invoiceRule.multi.day_week_deadline = rule.day_week_deadline
                this.invoiceRule.multi.week_deadline = rule.week_deadline

                this.invoiceRule.multi.active = rule.active
              }
            })
          }
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      vSelect
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// InvoiceRule.vue?b45cd62e